module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e2436"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2486"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c7_r1#d7e1",
      "id": "d6e1"
    }
  }, [_c('b', [_vm._v("Prologue")]), _vm._v(": War and Peace")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2576"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c8_r1#d7e2",
      "id": "d6e2"
    }
  }, [_c('b', [_vm._v("I")]), _vm._v(": “A Real Boom Town”")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2676"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c9_r1#d7e3",
      "id": "d6e3"
    }
  }, [_c('b', [_vm._v("II")]), _vm._v(": Hell Gate")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2766"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c10_r1#d7e4",
      "id": "d6e4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("III")]), _vm._v(": The Seeds of Madness")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2866"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c11_r1#d7e5",
      "id": "d6e5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("IV")]), _vm._v(": “Selected by Destiny”")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2956"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c12_r1#d7e6",
      "id": "d6e6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("V")]), _vm._v(": “A Man with a Hammer”")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e3056"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c13_r1#d7e7",
      "id": "d6e7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("VI")]), _vm._v(": Chasing Shadows")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e3146"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c14_r1#d7e8",
      "id": "d6e8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("VII")]), _vm._v(": The “Twelfth Street Prophet”")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e3246"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c15_r1#d7e9",
      "id": "d6e9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("VIII")]), _vm._v(": “The Greatest Manhunt in the History "), _c('br'), _vm._v(" of the Police Department”")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e3366"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c16_r1#d7e10",
      "id": "d6e10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("IX")]), _vm._v(": A City in Turmoil")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e3466"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c17_r1#d7e11",
      "id": "d6e11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("X")]), _vm._v(": Profile of a Bomber")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e3556"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c18_r1#d7e12",
      "id": "d6e12",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("XI")]), _vm._v(": Christmas in Manhattan")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e3656"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c19_r1#d7e13",
      "id": "d6e13",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("XII")]), _vm._v(": “An Innocent and Almost Absurdly "), _c('br'), _vm._v(" Simple Thing”")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e3786"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c20_r1#d7e14",
      "id": "d6e14",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("XIII")]), _vm._v(": “Plenty of Whacks”")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e3876"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c21_r1#d7e15",
      "id": "d6e15",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("XIV")]), _vm._v(": “The Four Fishermen”")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e4017"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c22_r1#d7e16",
      "id": "d6e16",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("XV")]), _vm._v(": Alice Kelly")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e4107"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c23_r1#d7e17",
      "id": "d6e17",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("XVI")]), _vm._v(": “The Price of Peace”")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e410a7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c24_r1",
      "id": "d6e1s7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Photo Insert")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e4207"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c40_r1#d7e18",
      "id": "d6e18",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("XVII")]), _vm._v(": “Your Next Door Neighbor”")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e4297"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c41_r1#d7e19",
      "id": "d6e19",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("XVIII")]), _vm._v(": Rewards, Accolades, and Accusations")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e4397"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c42_r1#d7e20",
      "id": "d6e20",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("XIX")]), _vm._v(": A Question of Competency")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e4487"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c43_r1#d7e21",
      "id": "d6e21",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("XX")]), _vm._v(": “As Plain as the Nose on Your Face”")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e4587"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c44_r1#d7e22",
      "id": "d6e22",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("XXI")]), _vm._v(": “His Days on Earth are Numbered”")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e4677"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c45_r1#d7e23",
      "id": "d6e23",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("XXII")]), _vm._v(": The Birth of Criminal Profiling")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e4777"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c46_r1#d7e24",
      "id": "d6e24",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("XXIII")]), _vm._v(": Right from Wrong")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e4867"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c47_r1#d7e25",
      "id": "d6e25",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("XXIV")]), _vm._v(": Matteawan")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e4967"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c48_r1#d7e26",
      "id": "d6e26",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Epilogue ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e5037"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c49_r1#d7e27",
      "id": "d6e27",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e5107"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c50_r1#d7e28",
      "id": "d6e28",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Author’s Note on Sources")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e5187"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c51_r1#d7e29",
      "id": "d6e29",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e5257"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/M_9781402789526_epub_c52_r1#d7e30",
      "id": "d6e30",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de6985d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/M_9781402789526_epub_c6_r1.vue
// module id = 72
// module chunks = 0